export const reportDetailModalState = {
  reportId: "",
  reportDetail: {},
  currentPageNumber: 1,
  openDrawer: true,
  totalPdfPages: null,
  showNotes: true,
  nurseFlag: false,
  alertStatus: false,
  clinicNotesEsig: false,
  processingReport: false,
  clinicNoteSubmitting: false,
  reportDate: "",
  isLegacyReport: false,
  reports: [],
  reportNoteList: [],
  severityIndex: 0,
  reportNote: {},
  undo: false,
  reportAccountDetail: null,
  reportCurrentTab: "",
  autoScrollPageNumber: null,
  maximumAlertPriority: null,
  alertNotificationConfigs: null,
  invalidBillingDateResponse: null,
  hasAlertBanner: false,
  isNonBillable: false,
  isCrossFacilityReport: false,
};
